import { faCopy, faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faCrown, faDesktop, faInfoCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Hotel } from 'ts/hotel/interfaces/HotelResponse';
import { showError, showSuccess } from 'utils/utils';
import { FC, Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MapHotelContext } from 'contexts/MapHotelContext';
import { getMonitorLink } from 'services/hotel';
import PreferredHotelModal from '../Modals/PreferredHotelModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useHotelProposal } from 'hooks/useProposal';
import { MainContext } from 'contexts/MainContext';
import { cdnUrl, trIco, gIco } from 'constants/generic';

interface HotelCardActionsPopupProps {
  hotel: Hotel;
  showActions: boolean;
  popupRef: any;
  setShowActions: (a: boolean) => void;
}

const HotelCardActionsPopup: FC<HotelCardActionsPopupProps> = ({ hotel, ...props }) => {
  const {
    t } = useTranslation();
  const [showPreferredHotelModal,
    setShowPreferredHotelModal] = useState(false);
  const { setCentered,
    setActiveTab } = useContext(MapHotelContext);
  const { user
  } = useContext(MainContext);
  const { toggleHotelProposal } = useHotelProposal();
  const onClickGoogle = () => {
    props.setShowActions(false);
    window.open(
      `https://www.google.com/search?q=Hotel ${hotel.item?.name}, ${hotel.addressInfo?.city}`,
      '_blank'
    );
  };
  const onClickTripadvisor = () => {
    props.setShowActions(false);
    window.open(
      `https://www.tripadvisor.com/Search?q=Hotel ${hotel.item?.name}, ${hotel.addressInfo?.city}`,
      '_blank'
    );
  };
  const onClickCopy = () => {
    props.setShowActions(false);
    navigator.clipboard.writeText(hotel.item?.name || '');
    showSuccess(t('mo.copied'));
  };

  const onClickFindNearly = () => {
    if (!hotel.position) return;
    props.setShowActions(false);
    setCentered({
      lat: hotel.position.latitude,
      lng: hotel.position.longitude,
    });
    setActiveTab(0);
  };

  const onClickMonitor = () => {
    props.setShowActions(false);
    const res = getMonitorLink(hotel, cdnUrl);

    if (res) {
      navigator.clipboard.writeText(res);
      showSuccess(t('mo.link_copied'));
    } else {
      showError(t('something_went_wrong'));
    }
  };

  const onClickPreferredHotel = () => {
    props.setShowActions(false);
    setShowPreferredHotelModal(true);
  };

  const onClickInfo = () => {
    setActiveTab(5);
    const roomsMobile = document.querySelector('.hotel-result-settings') as HTMLElement;
    roomsMobile?.classList.add('visible-responsive');
  };

  return (
    <Fragment>
      {props.showActions && (
        <div className="hotel-actions-popup-wr" ref={props.popupRef}>
          <div className="hotel-actions-popup-el" onClick={onClickGoogle}>
            <img
              width={18}
              src={gIco}
              alt="G"
              className="mr-3 position-relative top-1"
              style={{ top: '2px' }}
            />
            {t('hotel.google')}
          </div>
          <div className="hotel-actions-popup-el" onClick={onClickTripadvisor}>
            <img
              width={18}
              src={trIco}
              alt="T"
              className="mr-3 position-relative top-1"
              style={{ top: '2px' }}
            />
            {t('hotel.tripadvisor')}
          </div>
          <div className="hotel-actions-popup-el" onClick={onClickMonitor}>
            <FontAwesomeIcon icon={faDesktop} />
            {t('hotel.monitor')}
          </div>
          <div className="hotel-actions-popup-el" onClick={onClickCopy}>
            <FontAwesomeIcon icon={faCopy} />
            {t('hotel.copy')}
          </div>
          <div
            className="hotel-actions-popup-el"
            onClick={() => {
              props.setShowActions(false);
              toggleHotelProposal(hotel);
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            {t('hotel.proposal')}
          </div>
          <div className="hotel-actions-popup-el" onClick={onClickFindNearly}>
            <FontAwesomeIcon icon={faSearch} />
            {t('hotel.find_nearly')}
          </div>
          {user?.allowPreferredHotel && user?.branch?.hotelDisplaySupplierName && (
            <div className="hotel-actions-popup-el" onClick={onClickPreferredHotel}>
              <FontAwesomeIcon icon={faCrown} />
              {t('hotel.preferred_hotel')}
            </div>
          )}
          <div className="hotel-actions-popup-el" onClick={onClickInfo}>
            <FontAwesomeIcon icon={faInfoCircle} />
            {t('hotel.info')}
          </div>
        </div>
      )}

      {showPreferredHotelModal && (
        <PreferredHotelModal hotel={hotel} onClose={() => setShowPreferredHotelModal(false)} />
      )}
    </Fragment>
  );
};

export default withErrorBoundary(HotelCardActionsPopup, 'HotelCardActionsPopup');
